interface IStackNode<T> {
  value: T;
  next: IStackNode<T>;
}

export class Stack<T> {

  private _first: IStackNode<T> = null;
  private _last: IStackNode<T> = null;
  private _size = 0;

  public push(val: T): number {
    const newNode = this.getNode(val);

    if (!this._first) {
      this._first = newNode;
      this._last = newNode;
    } else {
      const temp = this._first;
      this._first = newNode;
      this._first.next = temp;
    }

    return ++this._size;
  }

  public pop(): T {
    if (!this._first) {
      return null;
    }

    const temp = this._first;

    if (this._first === this._last) {
      this._last = null;
    }

    this._first = this._first.next;
    this._size--;
    return temp.value;
  }

  private getNode(value: T): IStackNode<T> {
    return {
      value: value,
      next: null
    };
  }
}

